import { render, staticRenderFns } from "./FormsHome.vue?vue&type=template&id=45f687d1&scoped=true&"
import script from "./FormsHome.vue?vue&type=script&lang=js&"
export * from "./FormsHome.vue?vue&type=script&lang=js&"
import style0 from "./FormsHome.vue?vue&type=style&index=0&id=45f687d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f687d1",
  null
  
)

export default component.exports